import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import {blueColor, greyishBlue500} from "../../../../../assets/jss/main";

DesktopPopUpTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

function DesktopPopUpTitle({title, subtitle}) {
    return (
        <Grid container direction={"column"}>
            <span style={{
                color: blueColor,
                fontSize: '20px',
                fontWeight: 600
            }}>
                {title}
            </span>
            <span style={{
                color: greyishBlue500,
                fontSize: '16px',
                fontWeight: 400,
            }}>
                {subtitle}
            </span>
        </Grid>
    );
}

export default DesktopPopUpTitle;